import { render, staticRenderFns } from "./MenuSportello.vue?vue&type=template&id=7366f1b6&"
import script from "./MenuSportello.vue?vue&type=script&lang=ts&"
export * from "./MenuSportello.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports